import { FilterConfig } from '../../../model/filter';
import { Domain } from '../../../dtos/version.dto';

export const domainsFiltersConfig: FilterConfig<Domain> = {
    searchBox: { placeholder: 'Search Domain', byFields: ['name', 'domainUrl']}
};